export function segmentRuleFactory(customerSegments) {
  return async function segmentRule(node) {
    const { segmentsIncluded, segmentsExcluded } = node;

    if (!segmentsIncluded.length && !segmentsExcluded.length) {
      return true;
    }

    if (segmentsExcluded.some(segment => customerSegments.includes(segment))) {
      return false;
    }

    return (
      !segmentsIncluded.length ||
      segmentsIncluded.some(segment => customerSegments.includes(segment))
    );
  };
}
